(function(){
    var root = this;
    var Core = function(obj) {
        if (obj instanceof Core){
            return obj;
        }
        if (!(this instanceof Core)){
            return new Core(obj);
        }
    };

    root['Core'] = Core;

}).call(this);

Core.SetCache = function() {
    Core.Cache = {
        $window: $(window),
        $document: $(document),
        $body: $('body'),
        $html: $('html'),
        $loadingOverlay: $('#loading-overlay'),
        $lazyLoadingMessage: $('#lazy-loading-message'),
        $carousels: $('.carousel'),
        $backToTop: $('#btn-top'),
        $footer: $('.footer'),
        $miniCartTotal: $('a#toggle-cart span.amount'),
        $productListing: $('.product-list'),
    };
};

Core.Page = function(){
    Core.Page.init();
};

Core.IsMobile = function () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width <= Core.Config.MobileWidth) {
            return true;
        }
    }
    return false;
};

Core.IsTablet = function() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width <= Core.Config.TabletWidth) {
            return true;
        }
    }
    return false;
};

Core.HasKendoDropdowns = function(){
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        if (Core.Config.Forms.DropdownStylingTouchDevices) {
            return true;
        }
    }
    else if (Core.Config.Forms.DropdownStylingDesktop) {
        return true;
    }

    return false;
};

Core.RenderTemplate = function(templateName, data, $placeholder){
    var source = $(templateName).html();
    var template = Handlebars.compile(source);

    $placeholder.html(template(data));
};

Core.GetParameterByName = function(name){
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

Core.UpdateUrlParameter = function (uri, key, value) {
    // remove the hash part before operating on the uri
    var i = uri.indexOf('#');
    var hash = i === -1 ? '' : uri.substr(i);
    uri = i === -1 ? uri : uri.substr(0, i);

    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        uri = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        uri = uri + separator + key + "=" + value;
    }
    return uri + hash;  // finally append the hash as well
};

String.prototype.strim = function(needle) {
    var org = this;
    var modified = "";
    var first_pos = 0;
    var last_pos = org.length - 1;
    //find first non needle char position
    for (var i = 0; i < org.length; i++) {
        if (org.charAt(i) !== needle) {
            first_pos = (i === 0 ? 0 : i)

            break;
        }
    }
    // find first non needle char position
    for (var j = org.length - 1; j > 0; j--) {
        if (org.charAt(j) !== needle) {
            last_pos = (j === org.length ? org.length : j + 1);
            break;
        }
    }

    return org.substring(first_pos, last_pos);
};

Core.ShowLazyLoading = function () {
    Core.Cache.$lazyLoadingMessage.show();
};

Core.HideLazyLoading = function () {
    Core.Cache.$lazyLoadingMessage.hide();
};

Core.ShowPageLoading = function(){
    Core.Cache.$loadingOverlay.removeClass('hidden');
    Core.Cache.$loadingOverlay.show();
};

Core.ShowPageLoadingMessage = function(message){
    var msg = message || "";
        el = $('#loading-overlay');

    if(el.length === 0) {
        if(msg !== "")
            $('body').prepend('<div id="loading-overlay" class="loading-overlay has-message" style="display:block;"><span class="lv1"><span class="lv2">' + msg + '</span></span></div>');
        else
            $('body').prepend('<div id="loading-overlay" class="loading-overlay no-message" style="display:block;"></div>');        
    }else{
        if(msg !== "")
            el
                .addClass('has-message')
                .removeClass('no-message')
                .append('<span class="lv1"><span class="lv2">' + msg + '</span></span>')
                .show();
        else
            el
            .addClass('no-message')
            .removeClass('has-message')
            .html("")
            .show()
            .end();
    }
};

Core.HidePageLoading = function(){
    Core.Cache.$loadingOverlay.hide();
    var $el = $('#loading-overlay');
        
        $el.hide()
        if(!$el.hasClass("js-dontclear")) {
            $el.html("")
        }
        
        $el.removeClass('no-message has-message');

};

Core.InitPopup = function($popup, title) {
    var _width = 660, //Core.Config.CartNotification.Width,
        _height = 350;

    if (Core.IsMobile()) {
        _width = Core.Cache.$window.width();
    }

    var winEl = $popup.kendoWindow({
        title: title,
        width: _width,
        //height: _height,
        visible: false,
        iframe: false,
        modal: true,
        resizable: false,
        actions: ["Close"],
        pinned: true,
        draggable: false,
        appendTo: '#page-wrap'
    });

    winEl.data("kendoWindow").wrapper.addClass('portal-modal');
    var $closeBtn = $popup.find('.portal-modal__btn-close');

    if ($closeBtn) {
      $closeBtn.on('click', function() {
        Core.ShowPopup($popup, false);
      });
    }

    $popup.removeClass('hidden');
};

Core.ShowPopup = function($popup, doShow) {
    doShow = doShow === undefined || null ? true : doShow; //set default to true/show

    var popupWindow = $popup.data("kendoWindow");

    if (doShow) {
        popupWindow.center().open();
    } else {
        popupWindow.close();
    }        
};

Core.AppendErrorLabel = function($target, title) {
    var tmpl = "<label class='error'>" + title + "</label>";
    $target.append(tmpl);
};

Core.ShowErrorMessage = function ($errorBox, config, doShow) {
    doShow = doShow === undefined || null ? true : doShow; //set default to true/show

    if($errorBox.length === 0) {
        console.warn('No div.portal-error exist. Returned early.');
        return;
    }

    $errorBox.html('');
    if(!doShow) {
        $errorBox.addClass('hidden');
        return;
    }

    var initCloseBtn = function() {
        $errorBox.find('.portal-error__close').on('click', function() {
          $errorBox.addClass('hidden');
        });
    };

    if(config) {
        //add icon close
        var closeBtn = '<button type="button" class="portal-error__close">&times;</button>';
        $errorBox.append(closeBtn);

        if (config.title) {
            $errorBox.append('<h4 class="portal-error__title">' + config.title + '</h4>');
        }
    
        if (Array.isArray(config.message)) {
            $.each(config.message, function (i, msg) {
                $errorBox.append('<p class="portal-error__message">' + msg + '</p>');
            });
    
        } else {
            $errorBox.append('<p class="portal-error__message">' + config.message + '</p>');
        }

        initCloseBtn();
        $errorBox.removeClass('hidden');
        Core.ScrollToView($errorBox.offset().top - 10);
    }    
}

Core.ScrollToView = function(scrollTop) {
    $('html, body').animate({
        scrollTop: scrollTop
    }, 300);
};

Core.IsNumber = function (evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
};
Core.IsValidText = function (evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
   
    var regex = /^[a-zA-Z0-9]{5}$/;
    var y = String.fromCharCode(charCode);
    var isValid = regex.test(String.fromCharCode(evt.charCode));
    return isValid;
};
Core.SetCache();

Core.Cache.$document.ready(function () {
    Core.Engine.init();
    Core.Page({});
});
